module.exports = __webpack_public_path__ + "static/media/Imola.0fc848f5.jpg";